import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import authEn from '@/locales/en/auth.json';
import chatEn from '@/locales/en/chat.json';
import commonEn from '@/locales/en/common.json';
import discoverEn from '@/locales/en/discover.json';
import notesEn from '@/locales/en/notes.json';
import onboardingEn from '@/locales/en/onboarding.json';
import profileEn from '@/locales/en/profile.json';
import settingsEn from '@/locales/en/settings.json';
import subscriptionEn from '@/locales/en/subscription.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    auth: authEn,
    chat: chatEn,
    common: commonEn,
    discover: discoverEn,
    notes: notesEn,
    onboarding: onboardingEn,
    profile: profileEn,
    settings: settingsEn,
    subscription: subscriptionEn,
  },
} as const;

export type AvailableNamespaces = keyof (typeof resources)['en'];

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
